/* Visual size groups within the current filtered results; every size keeps its PDP. */
(() => {
  const normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim();

  function identify({ title, vendor, type }) {
    const name = normalise(title);
    if (!vendor || !/^(eau de parfum|eau de toilette|parfum|eau de cologne|extrait de parfum)$/.test(normalise(type))) return null;
    if (/\b(gift|set|refill(?:able)?|tester|pack|miniature|travel|deodorant|lotion|aftershave|mist)\b/.test(name)) return null;
    const sizes = [...name.matchAll(/\b(\d+(?:[.,]\d+)?)\s*ml\b/g)];
    if (sizes.length !== 1 || /\b\d+\s*[x×]/.test(name)) return null;
    const size = Number(sizes[0][1].replace(',', '.'));
    if (!(size > 0)) return null;
    return { key: [normalise(vendor), normalise(type), name.replace(sizes[0][0], '{size}')].join('|'), size };
  }

  function enhance() {
    const grid = document.querySelector('[data-kp-fragrance-families]');
    if (!grid) return;
    const items = [...grid.querySelectorAll(':scope > [data-kp-fragrance-title]')];
    const groups = new Map();
    items.forEach(item => {
      item.hidden = false;
      item.querySelector('.kp-fragrance-sizes')?.remove();
      const identity = identify({ title: item.dataset.kpFragranceTitle, vendor: item.dataset.kpFragranceVendor, type: item.dataset.kpFragranceType });
      if (!identity) return;
      if (!groups.has(identity.key)) groups.set(identity.key, []);
      groups.get(identity.key).push({ item, size: identity.size });
    });
    groups.forEach(group => {
      // Ambiguous duplicate volumes stay as separate cards.
      if (group.length < 2 || new Set(group.map(entry => entry.size)).size !== group.length) return;
      const primary = group[0].item;
      const info = primary.querySelector('.m-product-card__info');
      if (!info) return;
      const nav = document.createElement('nav');
      nav.className = 'kp-fragrance-sizes';
      nav.setAttribute('aria-label', grid.dataset.sizesLabel);
      const label = document.createElement('span');
      label.className = 'kp-fragrance-sizes__label';
      label.textContent = grid.dataset.sizesLabel;
      nav.append(label);
      group.slice().sort((a, b) => a.size - b.size).forEach(({ item, size }) => {
        const link = document.createElement('a');
        link.href = item.dataset.kpFragranceUrl;
        link.dataset.productId = item.dataset.kpFragranceId;
        link.textContent = `${size}ml`;
        link.setAttribute('aria-label', `${item.dataset.kpFragranceTitle} — ${item.dataset.kpFragrancePrice}`);
        if (item === primary) link.className = 'kp-fragrance-sizes__shown';
        nav.append(link);
      });
      info.append(nav);
      group.slice(1).forEach(({ item }) => { item.hidden = true; });
    });
  }

  if (typeof module === 'object' && module.exports) { module.exports = { identify }; return; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('collection:rerendered', enhance);
  document.addEventListener('kp:collection-products-added', enhance);
})();
